import { render } from "./SocialIconsStyleV4.vue?vue&type=template&id=c8862e12&scoped=true"
import script from "./SocialIconsStyleV4.vue?vue&type=script&lang=ts"
export * from "./SocialIconsStyleV4.vue?vue&type=script&lang=ts"

import "./SocialIconsStyleV4.vue?vue&type=style&index=0&id=c8862e12&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c8862e12"

export default script